import { translate } from '@components/translation/translation';
import { Lens } from '@icons';
import { debounce } from '@mui/material';
import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from 'react';
import { FormControl, InputGroup, Spinner } from 'react-bootstrap';

interface DebouncedSearchInputProps {
	onSearchTermChange: (term: string) => void;
	isLoading?: boolean;
}

export type DebouncedSearchInputRefType = {
	reset: () => void;
};

const DebouncedSearchInput = forwardRef<DebouncedSearchInputRefType, DebouncedSearchInputProps>(
	({ onSearchTermChange, isLoading }, ref) => {
		const [filterInputValue, setFilterInputValue] = useState('');

		const debouncedSetSearchTermRef = useRef(
			debounce((value: string) => {
				onSearchTermChange(value);
			}, 500),
		);

		const onFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
			const value = event.target.value;
			setFilterInputValue(value);
		};

		useImperativeHandle(ref, () => ({
			reset: () => setFilterInputValue(''),
		}));

		useEffect(() => {
			debouncedSetSearchTermRef.current(filterInputValue);
		}, [filterInputValue]);

		return (
			<InputGroup className="search-table align-items-center mt-md-0 ms-1" style={{ width: '300px' }}>
				<FormControl
					type="text"
					className="filter-text-box"
					placeholder={translate('common.search', 'Cerca') + '...'}
					value={filterInputValue}
					onChange={onFilterChange}
				/>
				<div style={{ width: '40px', textAlign: 'center' }}>
					{isLoading ? <Spinner animation="border" size="sm" /> : <Lens className="lens" />}
				</div>
			</InputGroup>
		);
	},
);

export default DebouncedSearchInput;
